module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"home":"Home","changelog":"Changelog","tasks":"Tasks","frens":"Frens"},"ru":{"home":"Главная","changelog":"Changelog","tasks":"Задачи","frens":"Друзья"}}')
  delete Component.options._Ctor
}
